// Components
import { UserForm } from "./UserForm";

const EditUser = () => {
  return <UserForm edit />;
};

export { EditUser };
